import React, { useState, useEffect } from 'react';

function SidebarLinkGroup({
  children,
  activecondition,
  upsideDown,
  exclusiveGroup,
  groupId
}) {

  const [open, setOpen] = useState(activecondition);
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth >= 1024);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  useEffect(() => {
    if (!exclusiveGroup || !groupId) return;

    const handleGroupOpen = (event) => {
      const { exclusiveGroup: openedGroup, groupId: openedId } = event.detail || {};
      if (openedGroup === exclusiveGroup && openedId !== groupId) {
        setOpen(false);
      }
    };

    window.addEventListener('sidebar-link-group-open', handleGroupOpen);
    return () => window.removeEventListener('sidebar-link-group-open', handleGroupOpen);
  }, [exclusiveGroup, groupId]);

  const handleClick = () => {
    // Only allow collapsing on lg screens and above
    if (isLargeScreen) {
      setOpen((prevOpen) => {
        const nextOpen = !prevOpen;
        if (nextOpen && exclusiveGroup && groupId) {
          window.dispatchEvent(
            new CustomEvent('sidebar-link-group-open', {
              detail: { exclusiveGroup, groupId },
            })
          );
        }
        return nextOpen;
      });
    }
  }

  // Always show as open on small screens, use state on large screens
  const isOpen = isLargeScreen ? open : true;

  return (
    <li className={`px-3 w-full py-2 rounded-sm mb-0.5 last:mb-0 ${activecondition && 'bg-theme-surface-accent'} ${upsideDown && 'flex flex-col-reverse'} `}>
      {children(handleClick, isOpen)}
    </li>
  );
}

export default SidebarLinkGroup;